module.exports = "/images/basurita20x20.svg";